module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":{"back":"Back","next":"Next","pressEnter":"Or click the \\"Enter\\" button!","step":"Step"}},"fr":{"label":{"back":"Retour","next":"Suivant","pressEnter":"Ou appuyez sur le bouton « Entrée »!","step":"Étape"}}}')
  delete Component.options._Ctor
}
